import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgGoal = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M8 12.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGoal);
export default ForwardRef;
